import { Navbar } from "../components/navbar";
import { connect } from "react-redux";
import { StoreState } from "../types";


function mapStateToProps(state: StoreState) {
  return {
    role: state.auth.role,
  };
}

export const NavbarContainer = connect(mapStateToProps)(Navbar);
